export const API_BASE   = "https://votelog.tsdevcut.co.za/wp-json/wp/v2/";
export const API_PMODEL = "https://votelog.tsdevcut.co.za/wp-json/ts/pageant/models/v1/";